import React, { useState } from "react";
import { OverflowMenu, OverflowMenuItem } from "carbon-components-react";

import UpdateOperatorModal from "./UpdateOperatorModal";
import CreatePinnedNoteModal from "./CreatePinnedNoteModal";

type Props = {
  appID: string;
};

enum OverflowModals {
  None,
  PipelineNote,
  AssignOperator,
}

const PipelineOverflowMenu = ({ appID }: Props) => {
  /**
   *  UI state
   */
  const [modalType, setModalType] = useState<OverflowModals>(OverflowModals.None);

  /**
   *  helper functions
   */
  const onModalExit = () => {
    setModalType(OverflowModals.None);
  };

  return (
    <>
      {/*
      N.b conditionally rending modal/form components here since they make requests when rendered.
      We'd like to avoid making a request for each loan app displayed in the pipeline view
       */}
      {modalType === OverflowModals.PipelineNote && (
        <CreatePinnedNoteModal appID={appID} onClose={onModalExit} />
      )}

      {modalType === OverflowModals.AssignOperator && (
        <UpdateOperatorModal appID={appID} onClose={onModalExit} />
      )}

      <OverflowMenu ariaLabel="add note, assign operator or view app">
        <OverflowMenuItem
          onClick={() => {
            setModalType(OverflowModals.PipelineNote);
          }}
          itemText="Create note"
        />

        <OverflowMenuItem
          onClick={() => {
            setModalType(OverflowModals.AssignOperator);
          }}
          itemText="Assign operator"
        />

        <OverflowMenuItem
          onClick={() => {
            window.open(`/underwriter/app/${appID}`);
          }}
          itemText="View loan"
        />
      </OverflowMenu>
    </>
  );
};

export default PipelineOverflowMenu;
